import { inject, observer } from "mobx-react";
import React from "react";
import Loader from "../../shared/Loader/Loader";
import Widget from "../Widget";
import { formatDateTime } from "../../shared/dateTimeUtils";
import "./LabDetail.scss";
import LabDetailStore from "./LabDetailStore";

class LabDetail extends Widget {
  constructor(props) {
    super(props);
    this.store = new LabDetailStore();
    this.store.fetchLabOrder({
      ...props.match.params,
      hasCorrections: props.match.path.indexOf("has-corrections") !== -1,
    });
  }

  render() {
    const labOrder = this.store.labOrder;
    const selectedValue = this.store.selectedValue;
    return (
      <div className="lab-detail widget">
        {this.store.loading ? (
          <Loader />
        ) : labOrder ? (
          <div className="lab-order">
            <h2>{labOrder.title}</h2>
            <h3 className="sub-title">
              {labOrder.subtitle}
              <div className="collection-time">
                {formatDateTime(labOrder.collectionTime, "-")}
              </div>
            </h3>
            <div className="values">
              <h2>Values</h2>
              {labOrder.values.map((value) => (
                <div
                  {...this.className({
                    "value-row": 1,
                    selected: this.store.selectedValue === value,
                  })}
                  key={value.dateTime}
                  onClick={() => this.selectValue(value)}
                >
                  <div className="status">{value.status}</div>
                  <div
                    className={`value normalcy-type-${value.normalcyType?.toLowerCase()}`}
                  >
                    {value.value}
                  </div>
                </div>
              ))}
            </div>

            <div className="details">
              <h2>Details</h2>
              <div className="detail">
                <div className="label">Ordering Physician</div>
                <div className="detail-value">{selectedValue.physician}</div>
              </div>
              <div className="detail">
                <div className="label">Specimen Collection</div>
                <div className="detail-value">
                  {formatDateTime(selectedValue.dateTime, "-")}
                </div>
              </div>
              <div className="detail">
                <div className="label">Reference Interval</div>
                <div className="detail-value">
                  {selectedValue.referenceInterval}
                </div>
              </div>
              <div className="detail">
                <div className="label">Specimen Source</div>
                <div className="detail-value"></div>
              </div>
              <div className="detail">
                <div className="label">Condition of Specimen</div>
                <div className="detail-value"></div>
              </div>
              <div className="detail">
                <div className="label">Report Release</div>
                <div className="detail-value"></div>
              </div>
              <div className="detail">
                <div className="label">Result Notes</div>
                <textarea
                  className="detail-value"
                  readOnly
                  value={selectedValue.notes
                    .filter((n) => n.format === "text")
                    .map((n) => n && n.body)
                    .join("\n")}
                />
              </div>
              <div className="detail">
                <div className="label">Order Notes</div>
                <div className="detail-value">{labOrder.notes.join(", ")}</div>
              </div>
              <div className="detail">
                <div className="label">Testing Facility</div>
                <div className="detail-value"></div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  selectValue(value) {
    this.store.selectedValue = value;
  }
}

export default inject("store")(observer(LabDetail));
